import React from 'react';

interface IzakayaConceptProps {
  lang: 'ja' | 'en';
}

export const IzakayaConcept: React.FC<IzakayaConceptProps> = ({ lang }) => {
  const content = {
    ja: {
      title: 'このような体験です',
      features: [
        {
          icon: 'ri-user-smile-line',
          title: '同行型スタイル',
          description: '観光ガイドではなく、地元の友人として一緒に楽しみます。堅苦しい説明はなく、自然な会話を楽しみましょう。'
        },
        {
          icon: 'ri-chat-3-line',
          title: '聞かれた時だけ解説',
          description: '気になることがあれば何でも聞いてください。でも基本は一緒にリラックスして楽しむ時間です。'
        },
        {
          icon: 'ri-team-line',
          title: '少人数制（最大4名）',
          description: '少人数だからこそ、アットホームな雰囲気で本当の東京の夜を体験できます。'
        },
        {
          icon: 'ri-heart-line',
          title: 'カジュアルな雰囲気',
          description: 'フォーマルなツアーではありません。友達と飲みに行くような、リラックスした時間を過ごしましょう。'
        }
      ]
    },
    en: {
      title: 'What to Expect',
      features: [
        {
          icon: 'ri-user-smile-line',
          title: 'Companion Style',
          description: 'Not a tour guide, but a local friend joining you. No formal explanations—just natural conversations and good times.'
        },
        {
          icon: 'ri-chat-3-line',
          title: 'Casual Explanations',
          description: 'Feel free to ask anything you\'re curious about. But mostly, we\'ll just relax and enjoy the night together.'
        },
        {
          icon: 'ri-team-line',
          title: 'Small Groups (Max 4)',
          description: 'Small groups create an intimate, homey atmosphere where you can truly experience authentic Tokyo nightlife.'
        },
        {
          icon: 'ri-heart-line',
          title: 'Relaxed Atmosphere',
          description: 'This isn\'t a formal tour. It\'s like going out for drinks with friends—casual, fun, and stress-free.'
        }
      ]
    }
  };

  const t = content[lang];

  return (
    <section className="py-20 px-6 bg-gradient-to-b from-white to-amber-50">
      <div className="max-w-6xl mx-auto">
        <h2 className="text-4xl md:text-5xl font-bold text-center text-gray-900 mb-16">
          {t.title}
        </h2>

        <div className="grid md:grid-cols-2 gap-8">
          {t.features.map((feature, index) => (
            <div
              key={index}
              className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-all duration-300 hover:-translate-y-1"
            >
              <div className="w-16 h-16 flex items-center justify-center bg-amber-100 rounded-full mb-6">
                <i className={`${feature.icon} text-3xl text-amber-600`}></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4">
                {feature.title}
              </h3>
              <p className="text-gray-600 leading-relaxed text-lg">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};